import { useFocusTrap } from "../hooks/useTrapFocus";
import { RefObject } from "react";

export const FocusTrapActivator = ({containerRef, onEscape}: { containerRef: RefObject<HTMLElement>; onEscape: () => void; }) => {
       useFocusTrap({ containerRef, onEscape });
       return null;
};
